import { get, post } from '@/utils/apiBase.js';
// 售后数据统计
const getRefundStatistics = option => {
    return get('/apis/mdcporder/refund/statistics', option)
}
// 售后单管理
const getRefundManager = option => {
    return get('/apis/mdcporder/refund/manager', option)
}
// 退款详情
const getRefundDetail = option => {
    return get('/apis/mdcporder/refund/detail', option)
}
// cp众筹退款审核
const postRefundAudit = option => {
    return post('/apis/mdcporder/refund/audit', option)
}
// 物流公司列表
const getExpressCompanyList = option => {
    return get('/mall/logistics_tools/express_company_list', option)
}
// cp售后单管理-列表
const getSaleOrderManager = option => {
    return get('/apis/cpaftersale/order_manager', option)
}
// 售后单发货
const postOrderDeliver = option => {
    return post('/apis/cpaftersale/order_deliver', option)
}
// 售后单统计
const getSaleOrderStatistics = option => {
    return get('/apis/cpaftersale/order_statistics', option)
}
// 售后单详情
const getSaleOrderDetail = option => {
    return get('/apis/cpaftersale/order_detail', option)
}
// 售后单日志
const getSaleOrderLog = option => {
    return get('/apis/cpaftersale/logs', option)
}
// 客服工单详情
const getWorkOrderDetail = option => {
    return get('/apis/cpaftersale/work_order_detail', option)
}
// 售后单审核
const postOrderAudit = option => {
    return post('/apis/cpaftersale/order_audit', option)
}
// 客服工单处理
const postWorkOrderAudit = option => {
    return post('/apis/cpaftersale/work_order_audit', option)
}
// cp售后单管理导出【异步】
const getSaleOlderExport = option => {
    return get('/apis/cpaftersale/order_manager_download', option)
}
// 检测cp售后单管理导出进度
const getQuerySaleOlderExport = option => {
    return get('/apis/cpaftersale/query_order_manager_download', option)
}
// 售后单管理导出
const getManagerDownload = option => {
    return get('/apis/mdcporder/refund/manager_download', option)
}
// 检测进度-售后单管理导出
const getQueryManagerDownload = option => {
    return get('/apis/mdcporder/refund/query_manager_download', option)
}

// 上传协商结果
const postAppealNegoAddInfo = option => {
    return post('/apis/cpaftersale/add_appeal_nego_info', option)
}

// 查看协商历史
const getAppealNegoLogInfo = option => {
    return get('/apis/cpaftersale/query_appeal_nego_info', option)
}


export default {
    getRefundStatistics,
    getRefundManager,
    getRefundDetail,
    postRefundAudit,
    getSaleOrderManager,
    getExpressCompanyList,
    postOrderDeliver,
    getSaleOrderStatistics,
    getSaleOrderDetail,
    getSaleOrderLog,
    getWorkOrderDetail,
    postOrderAudit,
    postWorkOrderAudit,
    getSaleOlderExport,
    getQuerySaleOlderExport,
    getManagerDownload,
    getQueryManagerDownload,
    postAppealNegoAddInfo,
    getAppealNegoLogInfo
};